<!--
  @component
  Generates an SVG multi-series line chart. It expects your data to be an array of objects, each with a `values` key that is an array of data objects.
 -->
<script>
	import { getContext } from "svelte";
	import { draw } from "svelte/transition";
	import { sineIn } from "svelte/easing";

	const CIRCLE_RADIUS = 3;

	const { data, xGet, yGet, zGet } = getContext("LayerCake");

	export let enterAnimation = false;
	export let linesEntered;

	$: path = (values) => {
		return (
			"M" +
			values
				.map((d) => {
					return $xGet(d) + "," + $yGet(d);
				})
				.join("L")
		);
	};
</script>

<g class="line-group">
	{#each $data as group}
		{#key group}
			<path
				in:draw={{ duration: enterAnimation ? 2000 : 0, easing: sineIn }}
				on:introstart={() => (linesEntered = false)}
				on:introend={() => (linesEntered = true)}
				class="path-line"
				d={path(group.values)}
				stroke={$zGet(group)}
			/>
			<circle 
				cx={$xGet(group.values[group.values.length - 1])}
				cy={$yGet(group.values[group.values.length - 1])}
				r={CIRCLE_RADIUS}
				fill={$zGet(group)}
				stroke="#000"
				/>
			<circle 
				cx={$xGet(group.values[0])}
				cy={$yGet(group.values[0])}
				r={CIRCLE_RADIUS}
				fill={$zGet(group)}
				stroke="#000"
				/>
		{/key}
	{/each}
</g>

<style>
	.path-line {
		fill: none;
		stroke-linejoin: round;
		stroke-linecap: round;
		stroke-width: 3px;
	}
</style>
